import { jsx as _jsx } from "react/jsx-runtime";
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
const FormBox = styled((props) => _jsx("form", { ...props, onSubmit: (event) => event.preventDefault() }), shouldNotForwardProps('fullHeight', 'sx'))(({ fullHeight }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    ...(fullHeight && { height: '100%' }),
}));
export { FormBox };
